import { franc } from "franc-min";

import { keywordLangs } from "@/components/suggestions/keywordLangs";

import type { KeywordLang } from "@corca/data";

const iso6393to1: Record<string, string> = {
  deu: "de",
  eng: "en",
  spa: "es",
  rus: "ru",
  zho: "zh",
  jpn: "ja",
  hin: "hi",
  fra: "fr",
  pol: "pl",
  por: "pt",
  ind: "id",
};

const iso6391to3 = Object.entries(iso6393to1).reduce<Record<string, string>>((acc, [key, val]) => {
  acc[val] = key;
  return acc;
}, {});

const latinLangs = ["de", "en", "es", "fr", "id", "pl", "pt"];

const langSubsetIso1 = ["en", ...keywordLangs];

/**
 * What franc may guess from the typed text. Indonesian is left out because franc takes short
 * English words for it (`beta` is an Indonesian pronoun), which would switch an English user's
 * search to Indonesian keywords; Indonesian users reach `id` through the browser language.
 */
const langSubset = langSubsetIso1.filter((lng) => lng !== "id").map((lng) => iso6391to3[lng]);

function getSystemLang() {
  return typeof navigator !== "undefined" &&
    langSubsetIso1.includes(navigator.language.split("-")[0] as KeywordLang)
    ? (navigator.language.split("-")[0] as KeywordLang)
    : null;
}

export function detectLanguage(str: string): KeywordLang {
  let lang = franc(str, { minLength: 3, only: langSubset });

  lang = iso6393to1[lang] ?? "en";

  const systemLang = getSystemLang();

  if (latinLangs.includes(lang) && systemLang && systemLang !== "en") {
    return systemLang;
  }

  return lang as KeywordLang;
}
